import {linear} from './linear';

export const easyOut = (timeFraction: number, timingFunction = linear) => {
    return 1 - timingFunction(1 - timeFraction);
};
